import React from 'react';
import './styles/empty.state.style.scss';

interface EmptyStateProps {
    icon: string;
    title: string;
    description: string;
    action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
    <div className='empty-state anim-fade-in-up'>
        <div className='empty-state__icon'>
            <i className={icon} />
        </div>
        <h5 className='empty-state__title'>{title}</h5>
        <p className='empty-state__description'>{description}</p>
        {action && <div className='empty-state__action'>{action}</div>}
    </div>
);
